import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type ComparatorOp = '==' | '!=' | '<' | '<=' | '>' | '>=' | 'in' | 'not in' | 'and' | 'or';

export type ComparatorControlPayload = {
  kind: 'comparatorControl';
  op: ComparatorOp;
  onChange: (next: ComparatorOp) => void;
};

@Component({
  selector: 'app-comparator-control',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './comparator-control.component.html',
  styleUrl: './comparator-control.component.scss',
})
export class ComparatorControlComponent {
  @Input({ required: true }) data!: ComparatorControlPayload;

  change(next: string): void {
    this.data.onChange(next as ComparatorOp);
  }
}

